/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 Shopify.handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};


function checkProductThumbnails(){

}

document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    
    $('.product-gallery__thumbnail-list').each(function() {
    var aryClasses = $(this).attr('class').split(' ');
      for (var i = 0; i < aryClasses.length; i++) {
          if (aryClasses[i].indexOf('current-image-') != -1) {
              $(this).removeClass(aryClasses[i]);
          }
      }
    });

    if (variant !== null) {
      var variantColour = variant.option1;
      variantColour = Shopify.handleize(variantColour);
      console.log(variantColour)
      var addNewClass = "current-image-" + variantColour;
      $('.product-gallery__thumbnail-list').addClass(addNewClass)
    }

    // setTimeout(function () {
    //   $.each($(".block-swatch"), function (i, element) {
    //
    //       console.log($(element).hasClass("block-swatch--disabled"))
    //
    //       if ($(element).hasClass("block-swatch--disabled")) {
    //
    //       } else {
    //         $(element).find("input").trigger('click');
    //         return false;
    //       }
    //
    //     // if (element.hasClass) {
    //     //   $(this).find("input").trigger('click');
    //     //   console.log(element)
    //     // }
    //
    //   });
    // }, 1000);

});

function upsellProductButton(variantId) {

  console.log(variantId)

    var item = {
      quantity: 1,
      id: variantId
    }

    $.ajax({
      url:	"/cart/add.js",
      type:	'POST',
      data: item,
      dataType: 'json'
    })
    .done(function(data) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         bubbles: true
      }));

      $(".header__cart-toggle .header__action-item-content").trigger( "click" );

      setTimeout(function () {
        $(".add-to-cart-bundle").prop("disabled",false);
      }, 200);

    })
    .fail(function(data) {
      alert(data.responseJSON.description)
    });
}


var coll = document.getElementsByClassName("Accordion");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("accordionactive");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "400px";
    }
  });
}

/*function inventoryTracker(event,onload){

    var data = tomitProductInventoryInfo.activeProduct;
    // console.log(data)
    if (onload === true) {
      var variantId = event;
      var activeVariant = data.variants[variantId];
    } else {

      if (event.detail.variant === null) {
        $('#inventoryLocationInformation').html('');
      } else {
        var variantId = event.detail.variant.id;
        var activeVariant = data.variants[variantId];
      }
    }


    if (activeVariant === undefined) {
      $('#inventoryLocationInformation').html('<p class="not-avaliable">Not Available In Store or Online</p>');
    } else {
      var locations = activeVariant['inventoryItem']['locations'];

      function checkLocation(data) {
        if (data === undefined) {
          return false
        } else {
          if (data.inStock === 1) {
              return true
          } else {
            return false
          }
        }
      }

      for (var i = 0; i < locations.length; i++) {
        if (locations[i].address === "392 Plenty Road") {
          var locationPlentyRoad = locations[i];
        } else if (locations[i].name === "Dropship/Order") {
          var locationDropship = locations[i];
        } else if (locations[i].address === "41A Quinn St") {
          var locationQuinnSt = locations[i];
        }
      }

        if (checkLocation(locationPlentyRoad)) {
          $('#inventoryLocationInformation').html('<p class="inv-avl">Available In Store and Online</p>');
        } else if (checkLocation(locationQuinnSt)) {
            $('#inventoryLocationInformation').html('<p class="inv-avl-ol">Available Online </p><a href="#" class="inv-modalbox">Click here to view in store</a>');
        } else if (checkLocation(locationDropship)) {
            $('#inventoryLocationInformation').html('<p class="not-avaliable">Available For Pre-Order</p>');
        } else {
            $('#inventoryLocationInformation').html('<p class="not-avaliable">Not Available In Store or Online</p>');
        }
      }
    }




document.addEventListener("DOMContentLoaded", function(event) {
  document.addEventListener('variant:changed', function(event) {
    inventoryTracker(event);
  });
});*/



